import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connectStream, compose } from '../../lib/bastetjs/utils/connectStream';
import { injectIntl } from 'react-intl';
import { EventResultsStreams } from '../../data/EventResultsStreams';
import { EventStreams } from '../../data/EventStreams';
import { extractRaceCourses } from '../../data/RaceStreams';
import { getTokenRacerId } from '../../utils/isLoggedIn';
import { eventBus } from '../../data/Streams';
import { getAthleteRacesStream } from '../../data/AthleteStreams';
import { connect } from 'react-redux';
import { getNotifications } from '../../data/NotificationStreams';
import { useFirebaseConfig } from '../../lib/firebase/remote-config';
import { EventResultsProps } from '../../utils/types';
import useEventMetadata from '../../hooks/useEventMetadata';
import { ReigniteEventResults } from './ReigniteEventResults';
import { useExtra } from '../../hooks/useExtra';
import { useMasterEvent } from '../../hooks/useMasterEvent';
import { useEventsMerged } from '../../hooks/useEventsMerged';

const PureEventResults = (props: EventResultsProps) => {
  const athlinksEventId = props.eventResultsFilters.date
  const eventMetadata = useEventMetadata(athlinksEventId)

  const { extra } = useExtra(props.masterId, athlinksEventId)
  const { eventsMerged, isEventsMergedLoading } = useEventsMerged(props.masterId, props.eventId)

  const { masterEvent } = useMasterEvent(props.masterId, props.eventId)
  const races = extractRaceCourses(masterEvent?.eventRaces)

  const firebaseConfig = useFirebaseConfig()
  if (!firebaseConfig.initialized) {
    // do not allow app to initialize results-hub if we don't have the remote config yet
    return null
  }

  return <ReigniteEventResults
    {...props}
    extra={extra}
    eventMetadata={eventMetadata}
    isFetchingMaster={isEventsMergedLoading}
    master={eventsMerged}
    races={races}
    selectedEvent={eventsMerged}
  />
}

const mapStateToProps = (state: any) => ({
  dispatch: undefined,
  eventMetadata: state.eventMetadata,
  eventResults: state.eventResults,
  eventResultsFilters: state.eventResultsFilters
});

export const EventResults = compose(
  connect(mapStateToProps),
  withTranslation(),
  injectIntl,
  connectStream({
    selectedEventStatus: ({ eventId, masterId }: any) => EventStreams.getEventStatus('ERP-current-event', { eventId, masterId }),
    search: () => eventBus.getTopic('event_results_search'),
    page: () => EventResultsStreams.getPage(),
    athleteRaces: () => getAthleteRacesStream(getTokenRacerId()),
    notifications: getNotifications
  }),
  withRouter,
)(PureEventResults);
